<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->
<div class="top-level-container">
  <div class="row-container">
    <div class="section-container">
      <angular-editor class="angular-editor" [ngModel]="completeSituationDescription"
        [config]="editorConfig"></angular-editor>
    </div>
  </div>
  @if (unreadArticles && +unreadArticles.count > 0) {
  <div class="row-container">
    <div class="section-container one-cell">
      <b>You have {{ unreadArticles.count }} unread Gallery item@if (+unreadArticles.count > 1) {
        <span>s</span>
        },
        <a mat-stroked-button href="{{ galleryUrl }}" target="_blank">click here to view them in Gallery</a></b>
    </div>
  </div>
  }
  <!-- Actions section -->
  @if (!showActions) {
  <div class="row-container">
    <div class="section-container four-cell">
      <div class="row-container">
        <div class="two-cell center-self">
          <button mat-icon-button (click)="showActions = true" title="Expand the actions">
            <mat-icon class="mdi-24px self-center" fontIcon="mdi-menu-down"></mat-icon>
          </button>
          <b title="Participant Actions during an Exercise">Actions:</b>
        </div>
        <div class="checkboxes-cell">&nbsp;</div>
      </div>
    </div>
  </div>
  }
  @if (showActions) {
  <div class="row-container">
    <div class="section-container mat-elevation-z8 four-cell">
      <div class="row-container">
        <div class="five-cell center-self">
          <button mat-icon-button (click)="showActions = false" title="Collapse the actions">
            <mat-icon class="mdi-24px self-center" fontIcon="mdi-menu-up"></mat-icon>
          </button>
          <b title="Participant Actions during an Exercise">Actions:</b>
        </div>
        @if (myTeamId === activeTeamId) {
        <div class="right-cell">
          @if (!isActionEditMode) {
          <button mat-icon-button (click)="isActionEditMode = true" title="Edit Actions"
            [disabled]="noChanges || !canSubmitTeamScore">
            <mat-icon class="mdi-24px" fontIcon="mdi-square-edit-outline">
            </mat-icon>
          </button>
          }
          @if (isActionEditMode) {
          <button mat-icon-button (click)="addOrEditAction(null)" style="outline: none; margin-left: 20px;"
            title="Add Action">
            <mat-icon class="mdi-24px self-center" fontIcon="mdi-plus-circle"></mat-icon>
          </button>
          }
          @if (isActionEditMode) {
          <button mat-icon-button (click)="isActionEditMode = false" style="outline: none; margin-left: 20px;"
            title="Close Action Editing">
            <mat-icon class="mdi-24px self-center" fontIcon="mdi-close-circle-outline"></mat-icon>
          </button>
          }
        </div>
        }
      </div>
      @for (action of actionList; track action.id) {
      <div class="row-container">
        @if (isActionEditMode) {
        <div>
          <button mat-icon-button (click)="addOrEditAction(action); $event.stopPropagation()" title="Edit Action">
            <mat-icon class="mdi-24px" fontIcon="mdi-square-edit-outline">
            </mat-icon>
          </button>
          <button mat-icon-button class="button-end" (click)="deleteActionRequest(action); $event.stopPropagation()"
            title="Delete Action">
            <mat-icon class="mdi-24px" fontIcon="mdi-trash-can-outline"></mat-icon>
          </button>
        </div>
        }
        <div class="center-self">
          @if (!isActionEditMode) {
          <mat-checkbox [checked]="action.isChecked" (change)="checkAction(action.id, $event.checked)"
            [matTooltip]="changedBy(action.id)"
            [disabled]="noChanges || myTeamId !== activeTeamId || !canContributeToTeamScore"></mat-checkbox>
          }{{ action.description }}
        </div>
      </div>
      }
    </div>
  </div>
  }
  <!-- Duties Section -->
  @if (!showDuties) {
  <div class="row-container">
    <div class="section-container four-cell">
      <div class="row-container">
        <div class="two-cell center-self">
          <button mat-icon-button (click)="showDuties = true" title="Expand the duties">
            <mat-icon class="mdi-24px self-center" fontIcon="mdi-menu-down"></mat-icon>
          </button>
          <b title="Participant Responsibilities during an Exercise">Duties:</b>
        </div>
        <div class="checkboxes-cell">&nbsp;</div>
      </div>
    </div>
  </div>
  }
  @if (showDuties) {
  <div class="row-container">
    <div class="section-container mat-elevation-z8 four-cell">
      <div class="row-container">
        <div class="five-cell center-self">
          <button mat-icon-button (click)="showDuties = false" title="Collapse the duties">
            <mat-icon class="mdi-24px self-center" fontIcon="mdi-menu-up"></mat-icon>
          </button>
          <b title="Participant Responsibilities during an Exercise">Duties:</b>
        </div>
        <div class="right-cell">
          @if (!isDutyEditMode) {
          <button mat-icon-button (click)="isDutyEditMode = true" title="Edit Duties"
            [disabled]="noChanges || !canSubmitTeamScore">
            <mat-icon class="mdi-24px" fontIcon="mdi-square-edit-outline">
            </mat-icon>
          </button>
          }
          @if (isDutyEditMode) {
          <button mat-icon-button (click)="addOrEditDuty(null)" style="outline: none; margin-left: 20px;"
            title="Add Duty">
            <mat-icon class="mdi-24px self-center" fontIcon="mdi-plus-circle"></mat-icon>
          </button>
          <button mat-icon-button (click)="isDutyEditMode = false" style="outline: none; margin-left: 20px;"
            title="Close Duty Editing">
            <mat-icon class="mdi-24px self-center" fontIcon="mdi-close-circle-outline"></mat-icon>
          </button>
          }
        </div>
      </div>
      @for (duty of dutyList; track duty.id) {
      <div class="row-container">
        @if (isDutyEditMode) {
        <div class="duty-cell">
          <button mat-icon-button (click)="addOrEditDuty(duty); $event.stopPropagation()" title="Edit Duty">
            <mat-icon class="mdi-24px" fontIcon="mdi-square-edit-outline">
            </mat-icon>
          </button>
          <button mat-icon-button class="button-end" (click)="deleteDutyRequest(duty); $event.stopPropagation()"
            title="Delete Duty">
            <mat-icon class="mdi-24px" fontIcon="mdi-trash-can-outline"></mat-icon>
          </button>
        </div>
        }
        <div class="five-cell center-self">
          <label>{{ duty.name }}</label>
        </div>
        <div class="five-cell center-self">
          @if (!isDutyEditMode && canContributeToTeamScore) {
          <mat-select placeholder="Assign Users" [value]="duty.users" multiple (opened)="openDutyUsers(duty)"
            (selectionChange)="updateDutyUsers(duty.id, $event)" (closed)="closeDutyUsers(duty.id)"
            [disabled]="noChanges || myTeamId !== activeTeamId" title="Select a Team Member">
            @for (membership of teamMemberships; track membership.id) {
            <mat-option [value]="getUser(membership.userId)">{{ getUserName(membership.userId) }}
            </mat-option>
            }
          </mat-select>
          }
          @if (isDutyEditMode || !canContributeToTeamScore) {
          <span>{{ getUserNames(duty.users) }}</span>
          }
        </div>
      </div>
      }
    </div>
  </div>
  }
  <!-- Roles Section -->
  @if (!showPermissions) {
  <div class="row-container">
    <div class="section-container four-cell">
      <div class="row-container">
        <div class="two-cell center-self">
          <button mat-icon-button (click)="showPermissions = true" title="Expand the permissions">
            <mat-icon class="mdi-24px self-center" fontIcon="mdi-menu-down"></mat-icon>
          </button>
          <b title="Participant permissions for this Exercise">Roles:</b>
        </div>
        <div class="checkboxes-cell">&nbsp;</div>
      </div>
    </div>
  </div>
  }
  @if (showPermissions) {
  <div class="row-container">
    <div class="section-container mat-elevation-z8 four-cell">
      <div class="row-container">
        <div class="two-cell center-self">
          <button mat-icon-button (click)="showPermissions = false" title="Collapse the permissions">
            <mat-icon class="mdi-24px self-center" fontIcon="mdi-menu-up"></mat-icon>
          </button>
          <b title="Participant permissions for this Exercise">Roles:</b>
        </div>
      </div>
      @for (teamMembership of teamMemberships; track teamMembership.id) {
      <div class="row-container">
        <div class="two-cell center-self">
          <label>{{ getUserName(teamMembership.userId) }}</label>
        </div>
        <div class="checkboxes-cell">
          <mat-form-field class="button-margins full-width">
            <mat-label>Role</mat-label>
            <mat-select placeholder="Role" [(ngModel)]="teamMembership.roleId"
              [disabled]="noChanges || !canManageTeam || teamMembership.userId === loggedInUserId">
              @for (role of teamRoles; track role.id) {
              <mat-option [value]="role.id">
                {{ role.name }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      }
    </div>
  </div>
  }
</div>
